import { DmsConnectionStatus } from './types';

export const dmsConnectionTranslation = (
  connectionStatus: DmsConnectionStatus | undefined,
  tr: any
): string => {
  switch (connectionStatus) {
    case DmsConnectionStatus.Connected:
      return tr('common.label.connection.connected');
    case DmsConnectionStatus.Loading:
      return `${tr('common.label.connection.connecting')}...`;
    case DmsConnectionStatus.Failed:
      return tr('common.label.failed');
    case DmsConnectionStatus.NotConnected:
    default:
      return tr('common.label.connection.notConnected');
  }
};
